import {
    Grid,
    Mui,
    MuiIcons,
    AlertTypes,
    BaseGenericItemsStore,
    GenericItemsForm,
    GenericItemsUtils,
    IGetAllParams,
    Spinner
} from "@leap4/frontend";
import type {GridColDef, GridRenderCellParams} from "@leap4/frontend";
import React, {useState} from "react";
import {urlService} from "../../../routing/urlsService";
import {baseBackendRoute} from "../../../../config/generals";
import {Link} from "react-router-dom";
import {deleteOwnership} from "../../../../actions/users";
import {useDispatch} from "react-redux";
import {setAlert} from "../../../../actions/alert";
import {IOrganization} from "../../interfaces/IOrganization";
import {AddOwnershipDialog} from "../../../App/AddOwnershipDialog";

const {Button, Divider, IconButton} = Mui;
const {Groups: GroupsIcon, DeleteForever: DeleteForeverIcon} = MuiIcons;

export interface IOrganizationProps {
    organization: IOrganization
}

const fields = {
    ORGANIZATIONS: 1,
    DATE: 1,
    PUBLISHER_TAG: 1,
    SUPPLY_TAG: 1,
    VALUE: 1,
    DELETE: 1,
}

const getParams: IGetAllParams = {
    fields
}

let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>


export const OwnershipDashboard = (props: IOrganizationProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isViewsPopupOpen, setViewsPopupOpen] = useState(false)
    const dispatch = useDispatch();



    function handleDelete(id: string) {
        (async () => {
            setIsLoading(true)
            try {
                await deleteOwnership(dispatch, id);
            } catch (err) {
                setAlert(err.toString(), AlertTypes.FAILURE)
            } finally {
                setIsLoading(false)
            }
        })()
    }

    function setStoreAndColumns(props: IOrganizationProps) {
        const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
            baseUrl: `${baseBackendRoute + urlService.getOwnershipsByOrgId(props.organization._id + '_' + props.organization.name)}`
        }, fields, {
            name: {editLinkFunc: () => urlService.getOwnershipsByOrgId(props.organization._id)},
            isActive: {},
            updated: {},
            created: {},
        })
        store = storeAndColumns.store;
        columns = storeAndColumns.columns;
        const nameCol = columns.find(x => x.field === "ORGANIZATIONS");
        const dateCol = columns.find(x => x.field === "DATE");
        const publisherTagCol = columns.find(x => x.field === "PUBLISHER_TAG");
        const supplyTagCol = columns.find(x => x.field === "SUPPLY_TAG");
        const valueCol = columns.find(x => x.field === "VALUE");
        const deleteCol = columns.find(x => x.field === "DELETE");
        valueCol.width = 100;
        dateCol.width = 100;
        supplyTagCol.width = 300;
        nameCol.renderCell = () => {
            return <Link
                to={urlService.editOrganization(props.organization._id)}>
                <strong>{props.organization.name}</strong></Link>
        }
        dateCol.renderCell = (params: GridRenderCellParams) => {
            return <>{params.row.timestamp.slice(0, 10)}</>
        }
        publisherTagCol.renderCell = (params: GridRenderCellParams) => {
            return <>{params.row.publisherTag}</>
        }
        supplyTagCol.renderCell = (params: GridRenderCellParams) => {
            return <>{params.row.supplyTag}</>
        }
        valueCol.renderCell = (params: GridRenderCellParams) => {
            if (params.row.ownershipValue === 0) {
                return <span><strong>{params.row.percent + "%"} </strong> </span>
            }
            return <span><strong>{params.row.ownershipValue}</strong> </span>
        }
        deleteCol.renderCell = (params: GridRenderCellParams) => {
            return <IconButton onClick={() => {handleDelete(params.row._id)}}><DeleteForeverIcon/></IconButton>
        }
    }

    setStoreAndColumns(props);

    return (
        <>
            <Grid margin={"30px"}>
                <h1>Ownerships</h1>
                <Divider/>
            </Grid>
            {isLoading ? (
                    <Grid margin={"30px"}>
                        <Spinner/>
                    </Grid>
            ) : (
            <Grid item width='100%' margin={"0px"}>
                <Grid item width='100%' margin={"0px"}>
                    <Button size="medium" variant="contained" color="primary"
                            disabled={isViewsPopupOpen || false}
                            onClick={() => {setViewsPopupOpen(true)}}>
                        <AddOwnershipDialog
                            isViewsPopupOpen={isViewsPopupOpen}
                            setViewsPopupOpen={setViewsPopupOpen}
                            organization={{id: props.organization._id, name: props.organization.name}}
                        />
                        {'ADD OWNERSHIP'}
                    </Button>
                </Grid>
                <GenericItemsForm
                    organization={props.organization.name}
                    columns={columns}
                    store={store}
                    breadcrumbsDisable={true}
                    breadcrumbs={{
                        link: urlService.publisherLogins(),
                        text: "Ownerships dashboard",
                        icon: <GroupsIcon/>
                    }}
                    tableProps={{pageSize: 100, style: {minHeight: "50vh"}}}
                    getAllParams={getParams}
                />
            </Grid>
             )}
        </>
    )
}



